import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserTimelinesModal } from '@wilson/interfaces';
import { GanttDimensionDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { ScoreDescription } from '@wilson/shift/core';
import { Observable, map } from 'rxjs';
import { calculateProductivityTimeDecimal } from '../../../productivity-score/calculate-productivity-time.fn';
import { generateScoreViewDetail } from '../../../productivity-score/score-view-detail.fn';
import { ScoreBarComponent } from '../score-bar/score-bar.component';

@Component({
  selector: 'wilson-productivity-score-display',
  templateUrl: './productivity-score-display.component.html',
  styleUrls: ['./productivity-score-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ScoreBarComponent, TranslateModule],
})
export class ProductivityScoreDisplayComponent implements OnInit {
  private ganttDimensionDataSourceService = inject(
    GanttDimensionDataSourceService,
  );

  @Input()
  userTimeline!: UserTimelinesModal;

  productivityScore$!: Observable<
    Pick<ScoreDescription, 'backgroundColor' | 'widthPercentage'>
  >;

  ngOnInit() {
    this.productivityScore$ = this.ganttDimensionDataSourceService
      .timeframeStream()
      .pipe(
        map((timeframe: Interval) => {
          const productivityScoreDecimal = calculateProductivityTimeDecimal(
            this.userTimeline,
            timeframe,
          );

          return generateScoreViewDetail(productivityScoreDecimal);
        }),
      );
  }
}
